import {
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import clsx from "clsx";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HttpClient from "libs/utils/HttpClient";
import { get } from "lodash";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import {
  changeActionStatus,
  configActionRoes,
  getActionRoles,
  getConfigActionList,
  getRoleList,
  setActiveAction,
} from "redux/modules/configActionSlice";
import store from "redux/store";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpButton: {
    marginTop: 30,
    textAlign: "right",
  },
  buttonSave: {
    marginLeft: 5,
    width: 120,
  },
  menuRow: {
    fontWeight: "500",
    padding: "10px 15px",
    borderBottom: "1px solid lightgray",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  subMenu: {
    marginLeft: "15px",
    cursor: "pointer",
    backgroundColor: "whitesmoke",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  listItem: {
    border: "1px solid lightgray",
    cursor: "pointer",
    "& span": {
      fontWeight: 500,
      fontSize: 13,
    },
  },
  actionSelected: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  roleCheckbox: {
    height: 20,
  },
}));

function ConfigActionDepartmentPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const masterData = useSelector(selectMasterData);
  const [open, setOpen] = React.useState(false);
  const [actionTxt, setActionTxt] = useState("");
  const [ActionList, setActionList] = useState([]);
  const department = get(masterData, "department", []);
  const [departmentCutBoi, setDepartmentCutBoi] = useState([]);
  const [ActionSelect, setActionSelect] = useState(false);
  const [CategoryId, setCategoryId] = useState("");
  const [CategoryName, setCategoryName] = useState("");
  const [detailChecked, setDetailChecked] = useState([]);

  const [state, setAction] = useState({
    actions: [],
    actionSelected: "",
  });

  const { list, roleSelected } = useSelector((state) => state.configAction);

  useEffect(() => {
    async function fetchData() {
      await dispatch(getConfigActionList());
      await dispatch(getRoleList());
      await dispatch(getActionRoles());
    }
    fetchData();
  }, [dispatch]);

  const handleOnSelectSubMenu = (actionMenu) => {
    const actionNo = actionMenu.length > 0 ? actionMenu[0].actionNo : null;
    setAction({ actions: actionMenu, actionSelected: actionNo });
    dispatch(setActiveAction(actionNo));
  };

  const handleOnSelectAction = (actionNo) => {
    setAction({ ...state, actionSelected: actionNo });
    dispatch(setActiveAction(actionNo));
  };

  const handleChangeRole = (selected, role) => {
    const action = state.actions.find(
      (x) => x.actionNo === state.actionSelected
    );
    dispatch(
      changeActionStatus({
        role: role,
        selected: selected,
        actionData: action,
      })
    );
  };

  //   const handleSaveChange = async () => {
  //     const { dispatch, getState } = store;

  //     const actinRoles = getState().configAction.actionRoles.filter(
  //       (x) =>
  //         (x.laststatus && x.laststatus !== x.status) ||
  //         (x.isNew && x.status === "Y")
  //     );

  //     for (const action of actinRoles) {
  //       const body = {
  //         role: action.role,
  //         menuNo: action.menuNo,
  //         subMenuNo: action.subMenuNo,
  //         actionNo: action.actionNo,
  //         status: action.status,
  //       };
  //       await dispatch(configActionRoes(body));
  //     }

  //     setAction({ actions: [], actionSelected: "" });
  //     await dispatch(getConfigActionList());
  //     await dispatch(getRoleList());
  //     await dispatch(getActionRoles());
  //   };

  const submitAction = async () => {
    if (actionTxt !== "") {
      const body = {
        checkpropertiesID: null,
        checkpropertiesName: actionTxt,
        Status: true,
        detail: [],
      };
      try {
        const response = await HttpClient.post(
          `/api/visaformadmin/checkproperties/add`,
          body
        );
        if (response.status) {
          console.log(response);
          alert("สำเร็จ");
          setActionTxt("");
          setOpen(false);
          getActionList();
          return response;
        }
        return Promise.reject(response);
      } catch (error) {
        const newError = error;
        throw newError;
      }
    } else {
      alert("กรุณาพิมพ์ข้อมูล");
    }
  };

  const getActionList = async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/checkproperties/list`
      );
      if (response.status) {
        setActionList(response?.results);
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const getActionListDetail = async (id) => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/checkproperties/list?checkpropertiesID=${id}`
      );
      if (response.status) {
        setDetailChecked(response?.results[0].departments);
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const addDetailSelected = (id, bool) => {
    const index = detailChecked.findIndex((obj) => obj.departmentId === id);

    if (index > -1) {
      //make sure you found it
      detailChecked.splice(index, 1);
      const data = {
        departmentId: id,
        status: bool,
      };
      setDetailChecked([...detailChecked, data]);
    } else {
      const data = {
        departmentId: id,
        status: true,
      };
      setDetailChecked([...detailChecked, data]);
    }

    // const found = detailChecked.find((obj) => {
    //   return obj.departmentId === id;
    // });

    // if (found) {
    //   let index = detailChecked.findIndex((i) => i.departmentId === id);
    //   detailChecked.splice(index, 1);
    //   setDetailChecked([...detailChecked]);
    // } else {
    //   const data = {
    //     departmentId: id,
    //     status: true,
    //   };
    //   setDetailChecked([...detailChecked, data]);
    // }
  };

  const handleSaveChange = async () => {
    const body = {
      checkpropertiesID: CategoryId,
      checkpropertiesName: CategoryName,
      Status: true,
      detail: detailChecked,
    };
    try {
      const response = await HttpClient.post(
        `/api/visaformadmin/checkproperties/add`,
        body
      );
      if (response.status) {
        console.log(body);
        console.log(response);
        alert("สำเร็จ");
        setCategoryId("");
        setCategoryName("");
        setActionSelect(false);
        getActionList();
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  useEffect(async () => {
    await getActionList();
    await dispatch(
      getMasterData({
        department: true,
      })
    );
  }, []);

  useEffect(() => {
    let index = department.findIndex(
      (i) => i.departmentId === "ba3184c1-652f-4632-8d4f-3a5bae4e9349"
    );
    const newArr = [...department];
    newArr?.splice(index, 1);
    setDepartmentCutBoi([...newArr]);
  }, [department]);

  return (
    <>
      {/* {console.log(detailChecked)} */}
      <Paper className={classes.paper}>
        <AdminTitle title="Setting" subTitle="ตั้งค่า เรื่องที่ตรวจสอบ" />

        <div className={classes.warpButton}>
          {ActionSelect ? (
            <Button
              variant="contained"
              size="medium"
              color="primary"
              className={classes.buttonSave}
              onClick={() => handleSaveChange()}
            >
              Save
            </Button>
          ) : null}
        </div>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Grid container>
              <Grid item>
                {" "}
                <h4>เรื่องที่ตรวจสอบ</h4>
              </Grid>
              <Grid item xs>
                <Grid container direction="row-reverse">
                  <Grid item>
                    <AddIcon onClick={() => setOpen(true)} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <div>
              {ActionList.map((l) => (
                <div key={l.checkpropertiesID}>
                  <div
                    className={classes.menuRow}
                    onClick={async () => {
                      setCategoryId(l?.checkpropertiesID);
                      setCategoryName(l?.checkpropertiesName);

                      await getActionListDetail(l.checkpropertiesID);
                      setActionSelect(true);
                    }}
                  >
                    {l.checkpropertiesName}
                  </div>
                </div>
              ))}
            </div>
          </Grid>

          <Grid item xs={12} md={4}>
            <h4>หน่วยงานรับรอง</h4>
            {/* {console.log(detailChecked)} */}
            <List>
              {ActionSelect &&
                departmentCutBoi.map((row, index) => (
                  <ListItem key={index} className={clsx(classes.listItem)}>
                    <ListItemIcon>
                      <Checkbox
                        className={classes.roleCheckbox}
                        color="primary"
                        edge="start"
                        spacing={1}
                        checked={detailChecked.some((x) => {
                          return (
                            x?.departmentId === row?.departmentId &&
                            x?.status === true
                          );
                        })}
                        onChange={async (e) => {
                          console.log(e.target.checked);
                          if (e.target.checked) {
                            await addDetailSelected(row?.departmentId, true);
                          } else {
                            await addDetailSelected(row?.departmentId, false);
                          }
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={row?.departmentName} />
                  </ListItem>
                ))}
            </List>
          </Grid>
        </Grid>
      </Paper>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>เพิ่มหัวข้อ</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="หัวข้อ"
            name="actionTxt"
            fullWidth
            variant="standard"
            onChange={(e) => setActionTxt(e.target.value)}
            value={actionTxt}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>ยกเลิก</Button>
          <Button onClick={() => submitAction()}>ตกลง</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ConfigActionDepartmentPage;
